(() => {
  const initialize = (scope = document) => scope.querySelectorAll('[data-price-downloads]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const label = root.querySelector('[data-download-market-label]');
    const hubs = { Johannesburg: 'johannesburg', 'Cape Town': 'cape-town' };
    const countries = { NA: ['namibia', 'Namibia — Windhoek'], BW: ['botswana', 'Botswana — Gaborone'], SZ: ['eswatini', 'Eswatini — Ezulwini'] };
    let selectedMarket = null;
    let busy = false;
    const status = root.querySelector('[data-download-status]');
    const errorMessage = root.dataset.error;
    const buttons = [...root.querySelectorAll('[data-download-collection]')];
    const syncMarket = (hub) => {
      if (root.dataset.country === 'ZA') {
        selectedMarket = Object.hasOwn(hubs, hub) ? hubs[hub] : null;
        label.textContent = selectedMarket ? hub : root.dataset.chooseBranch;
      } else {
        const country = countries[root.dataset.country];
        selectedMarket = country?.[0] || null;
        label.textContent = country?.[1] || root.dataset.unavailable;
      }
      buttons.forEach(button => { button.disabled = busy || !selectedMarket; });
    };
    const currentHub = () => {
      const dialog = document.querySelector('[data-location-dialog]');
      const selected = dialog?.querySelector('[data-location-option][aria-selected="true"]')?.dataset.locationOption;
      if (selected) return selected;
      if (Object.hasOwn(hubs, dialog?.dataset.initialHub)) return dialog.dataset.initialHub;
      try { return window.localStorage.getItem('mywaste-production-hub'); } catch { return null; }
    };
    syncMarket(currentHub());
    document.addEventListener('hub:change', event => syncMarket(event.detail.hub));
    window.addEventListener('pageshow', () => syncMarket(currentHub()));
    buttons.forEach(button => button.addEventListener('click', async () => {
      if (busy || !selectedMarket) return;
      const downloadMarket = selectedMarket;
      busy = true;
      buttons.forEach(item => { item.disabled = true; });

      button.setAttribute('aria-busy', 'true');
      status.textContent = root.dataset.loading;
      status.dataset.error = 'false';
      try {
        const endpoint = new URL(root.dataset.endpoint || 'https://mywaste-store-services.vercel.app/api/price-list');
        if (endpoint.protocol !== 'https:' && endpoint.hostname !== 'localhost') throw new Error('Invalid service');
        endpoint.searchParams.set('market', downloadMarket);
        endpoint.searchParams.set('collection', button.dataset.downloadCollection);
        const response = await fetch(endpoint, { signal: AbortSignal.timeout(300000) });
        if (!response.ok || !response.headers.get('content-type')?.startsWith('application/pdf')) throw new Error('Download unavailable');
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `MYWASTE-${downloadMarket}-${button.dataset.downloadCollection}-Price-List.pdf`;
        document.body.append(link); link.click(); link.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 60000);
        status.textContent = root.dataset.success;
      } catch {
        status.textContent = errorMessage;
        status.dataset.error = 'true';
      } finally {
        busy = false;
        buttons.forEach(item => { item.disabled = !selectedMarket; });
        button.removeAttribute('aria-busy');
      }
    }));
  });
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
